import ErrorLayout from '@local/common/ui/components/layout/ErrorLayout';
import IllustratedErrorMessage, {
    IllustratedErrorMessageProps,
} from '@local/common/ui/components/error/IllustratedErrorMessage';
import Box from '@mui/material/Box';

interface ErrorPageProps {
    statusCode: IllustratedErrorMessageProps['statusCode'];
    dataTestId?: string;
}

export default function ErrorPage({ statusCode, dataTestId = 'error-page' }: ErrorPageProps) {
    return (
        <Box data-testid={dataTestId}>
            <ErrorLayout>
                <IllustratedErrorMessage statusCode={statusCode} />
            </ErrorLayout>
        </Box>
    );
}
